import { ESMExitedStockItem, ESMExitedStocksFilterOptions } from '@/types/esmExitedStocks';
import { apiClient } from './client';

export const getESMExitedStocksFilterOptions = (): ESMExitedStocksFilterOptions => {
  return {
    stock_name: '',
    watchlists: []
  };
};

/**
 * Fetch ESM exited stocks based on filter criteria
 */
export const getESMExitedStocks = async (filters: Record<string, unknown> = {}): Promise<ESMExitedStockItem[]> => {
  try {
    const response = await apiClient.get('/market/esm-exited-stocks', {
      params: filters
    });
    
    // Type assertion for response structure
    const responseData = response.data as { data: ESMExitedStockItem[] };
    
    // Ensure we have a valid response structure
    if (!responseData.data) {
      console.warn('Unexpected API response structure:', responseData);
      return [];
    }
    
    return responseData.data || [];
  } catch (error) {
    console.error('Error fetching ESM exited stocks:', error);
    throw error;
  }
};
